import { createStyles, makeStyles } from '@material-ui/core';
import { IMG_BG } from 'shared/constants/ASSETS_URL';
import { COLORS } from 'shared/constants/COLORS';
const {
  PRIMARY_BUTTON_BORDER,
  DARKER_CONTAINER_TRANSPARENT,
  DARK_CONTAINER_FIELDS_FLOATING,
  ERROR_TEXT,
  LIGHT_TEXT,
  DARK_CONTAINER_FIELDS_ON_CARD,
  LIGHT_CONTAINER_FIELDS_ON_CARD,
  LIGHT_CONTAINER_FIELDS_FLOATING,
  OFFWHITE_CONTAINER_TRANSPARENT,
  PRIMARY_CONTAINER_BORDER,
  PRIMARY_TEXT,
} = COLORS;

export const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      gap: '2.5em',
      alignItems: 'center',
      width: '100%',
      borderRadius: 8,
      padding: 30,
      backgroundImage:
        theme.palette.type === 'dark'
          ? `linear-gradient(270deg, ${DARKER_CONTAINER_TRANSPARENT} 0%, ${DARK_CONTAINER_FIELDS_FLOATING} 30%), url(${IMG_BG})`
          : `linear-gradient(270deg, ${OFFWHITE_CONTAINER_TRANSPARENT} 0%, ${LIGHT_CONTAINER_FIELDS_FLOATING} 30%), url(${IMG_BG})`,
      backgroundSize: 'auto 100%',

      [theme.breakpoints.down('xs')]: {
        backgroundImage:
          theme.palette.type === 'dark'
            ? `linear-gradient(270deg, ${DARKER_CONTAINER_TRANSPARENT} 0%, ${DARK_CONTAINER_FIELDS_FLOATING} 30%), url(${IMG_BG})`
            : `linear-gradient(270deg, ${OFFWHITE_CONTAINER_TRANSPARENT} 0%, ${LIGHT_CONTAINER_FIELDS_FLOATING} 30%), url(${IMG_BG})`,
      },
    },
    qrContainer: {
      height: 299,
      width: 299,
      background:
        theme.palette.type === 'dark' ? DARK_CONTAINER_FIELDS_ON_CARD : LIGHT_CONTAINER_FIELDS_ON_CARD + '!important',
      border: `1px solid ${PRIMARY_CONTAINER_BORDER}`,
      borderStyle: 'solid',
      borderWidth: '3px',
      borderImageSlice: '1',
      backgroundOrigin: 'border-box',
      backgroundClip: 'content-box, border-box',
      borderRadius: '8px !important',
      cursor: 'pointer',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    input: {
      marginTop: '20px!important',
      '& .MuiInputBase-root': {
        height: '44px!important',
        '& fieldset': {
          borderRadius: 8,
          border: `solid 1px ${PRIMARY_BUTTON_BORDER}`,
        },
      },

      '& .MuiInputAdornment-positionStart': {
        marginRight: 15,
      },

      '& .MuiSvgIcon-root': {
        fontSize: 20,
      },

      '& input::placeholder': {
        color: LIGHT_TEXT,
        letterSpacing: 0.4,
        fontWeight: 500,
        opacity: 0.9,
      },

      '& .MuiFormHelperText-root': {
        color: ERROR_TEXT,
        margin: '10px 0 0',
        fontSize: 14,
      },
    },
    buttonCls: {
      marginTop: 10,
      height: '44px !important',
      borderRadius: 8,
      textTransform: 'unset',
      maxWidth: 320,
      fontSize: 15,
    },
    link: {
      color: PRIMARY_TEXT,
      textDecoration: 'underline',
    },
  }),
);
